import { render, staticRenderFns } from "./BackTestDetail.vue?vue&type=template&id=73de33ae&scoped=true&"
import script from "./BackTestDetail.vue?vue&type=script&lang=js&"
export * from "./BackTestDetail.vue?vue&type=script&lang=js&"
import style0 from "./BackTestDetail.vue?vue&type=style&index=0&id=73de33ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73de33ae",
  null
  
)

export default component.exports